import { Paper, Theme } from "@mui/material";
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import * as React from "react";

const styles = (theme: Theme) => createStyles({
    paperBlock: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.grey["200"]
    }
})

interface IProps {
}

type Props = IProps & WithStyles<typeof styles>;

const MuiWell: React.FC<Props> = (props) => {
    const { classes } = props;
    return (
        <Paper className={classes.paperBlock} elevation={4}>
            {props.children}
        </Paper>
    );
}

export default withStyles(styles)(MuiWell);